import { screeningTicketEntityRiskPDF } from 'components/Common/EntityTicketPdf';
import { RiskEvaluation } from './entityRiskEvaluation';
import { buildEntityRiskReport, riskReportFileName } from './entityRiskReport';

/**
 * Downloads the Export and Transshipment Risk report PDF. The record's Export
 * menu offers it once a run has left a result to read. Built in the browser
 * from that result, so it is the same document the report page shows.
 */
export const downloadEntityRiskReportPdf = async (input: {
  evaluation: RiskEvaluation;
  entityName: string;
  country?: string | null;
  preparedBy: string;
}): Promise<void> => {
  const report = buildEntityRiskReport(input.evaluation, {
    entityName: input.entityName,
    country: input.country,
  });
  await screeningTicketEntityRiskPDF(
    { report: report, preparedBy: input.preparedBy },
    riskReportFileName(report),
  );
};
